import { KeycloakOptions, KeycloakService } from 'keycloak-angular';
import { inject, InjectionToken } from '@angular/core';
import {isLightRoute} from "@adlatus-gui/shared";

export const KEYCLOAK_OPTIONS = new InjectionToken<KeycloakOptions>('keycloakOptions');

export const initializeKeycloak = (keycloak: KeycloakService) => {
  const keycloakOptions = inject(KEYCLOAK_OPTIONS);
  return () => {
    if (isLightRoute()) return Promise.resolve();
    return keycloak.init(keycloakOptions);
  };
};
